import { combineEpics, ofType } from 'redux-observable'
import { from, of, combineLatest } from 'rxjs'
import { catchError, switchMap, map } from 'rxjs/operators'
import { Action, Actions } from '../actionTypes'
import { ActionsObservable, AppState, StateObservable } from '..'
import {
  analyticsReady,
  pageAnalyticsFailed,
  pageAnalyticsSuccess,
  updateAnalyticsProperties,
  updateAnalyticsPropertiesReady,
} from './actions'
import { fireProtoPageView } from 'src/modules/analytics/v3'
import { SET_MARKET_SUCCESS } from '../market/actionTypes'

const analyticsReadyEpic = (action$: ActionsObservable): any => {
  const deviceReady$ = action$.pipe(ofType(Actions.DEVICE_READY))
  const marketReady$ = action$.pipe(ofType(SET_MARKET_SUCCESS))
  return combineLatest([marketReady$, deviceReady$]).pipe(switchMap(() => from([analyticsReady()])))
}

const sendPageAnalyticsEpic = (action$: ActionsObservable, state$: StateObservable): any =>
  action$.pipe(
    ofType(Actions.ANALYTICS_READY),
    switchMap(() =>
      from(fireProtoPageView(state$.value)).pipe(
        map((analyticsProperties) => {
          if (analyticsProperties?.properties) {
            return [
              updateAnalyticsProperties(analyticsProperties.properties),
              updateAnalyticsPropertiesReady(),
              pageAnalyticsSuccess(),
            ]
          }
          return [pageAnalyticsSuccess()]
        }),
        switchMap((actions) => of(...actions)),
        catchError((error) => {
          console.debug(error)
          return of(pageAnalyticsFailed())
        })
      )
    )
  )

export const analyticsEpic = combineEpics<Action, Action, AppState>(
  analyticsReadyEpic,
  // fireCohortingEventEpic,
  sendPageAnalyticsEpic
)
